




import { Component, Prop, Vue } from 'vue-property-decorator';
import EventCalendarHoliday from '@/containers/pages/EventCalendarHoliday.vue';

@Component({ components: { EventCalendarHoliday } })
export default class EventCalendarHolidayReadOnly extends Vue {}
